import { atom } from "recoil"
import { ToolTypes } from "../types/Tools"

export const toolState = atom<ToolTypes>({
	key: "TOOL_STATE",
	default: ToolTypes.NONE
})